import { FC, useEffect } from 'react';
import { VStack, Button } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { CreateCardDeckData } from '@olagg/db-types';
import OlaggForm from '../../components/Forms/OlaggForm';
import OlaggFormInput from '../../components/Forms/OlaggFormInput';
import { formCardDeckSchema } from '@olagg/validation-schemas/cardDecks.schemas';
import { yupResolver } from '@hookform/resolvers/yup';

interface CardDeckFormProps {
  onSubmit: (dataForm: CreateCardDeckData) => void;
  cardDeck?: CreateCardDeckData;
}

const CardDeckForm: FC<CardDeckFormProps> = ({ onSubmit, cardDeck }) => {
  const useFormMethods = useForm<CreateCardDeckData>({
    resolver: yupResolver(formCardDeckSchema),
    mode: 'onChange',
  });

  useEffect(() => {
    if (cardDeck) {
      useFormMethods.reset(cardDeck);
    }
  }, [cardDeck]);

  return (
    <OlaggForm
      useFormMethods={useFormMethods}
      onSubmit={onSubmit}
      style={{
        width: '100%'
      }}
    >
      <VStack spacing={4} maxW='600px' margin='0 auto'>
        <OlaggFormInput
          label='Nombre'
          controlName='name'
          required={true}
        />

        <OlaggFormInput
          label='Nombre (ingles)'
          controlName='nameEn'
          required={true}
        />

        <OlaggFormInput
          label='Nombre (portugues)'
          controlName='namePt'
          required={true}
        />

        <OlaggFormInput
          label='Descripción'
          description='Permite contenido en markdown'
          controlName='description'
          required={true}
        />

        <OlaggFormInput
          label='Descripción (ingles)'
          description='Permite contenido en markdown'
          controlName='descriptionEn'
          required={true}
        />

        <OlaggFormInput
          label='Descripción (portugues)'
          description='Permite contenido en markdown'
          controlName='descriptionPt'
          required={true}
        />

        <OlaggFormInput
          label='Pack cooldown'
          description='Tiempo en segundos que un usuario debe esperar para poder abrir un nuevo pack'
          controlName='packCooldownSeconds'
          required={true}
        />

        <OlaggFormInput
          label='Cantidad mínima de cartas por pack'
          controlName='minCardsPerPack'
          required={true}
        />

        <OlaggFormInput
          label='Cantidad máxima de cartas por pack'
          controlName='maxCardsPerPack'
          required={true}
        />

        <OlaggFormInput
          label='URL de la imagen de portada'
          controlName='coverImageUrl'
          required={true}
        />

        <OlaggFormInput
          label='URL de la imagen de reverso de carta'
          description='Es la imagen que se muestra cuando una carta aún no ha sido revelada'
          controlName='unrevealedImageUrl'
          required={true}
        />

        <Button
          variant={'filledGradient'}
          type="submit"
          w={'full'}
          style={{
            marginTop: '30px'
          }}
        >
          Guardar
        </Button>
      </VStack>
    </OlaggForm>
  );
};

export default CardDeckForm; 